import { MAPKEY } from '../actionTypes';
const initialState = ""

export const mapKeyReducer = (state = initialState, action) => {
    switch (action.type) {
        case MAPKEY:
            return action.data
        default:
            return state;
    }
};
